var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCursoPilates(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 43,
    viewBox: "0 0 84 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61.0728,
    cy: 6.88134,
    r: 6.88134,
    fill: "#9B5AE6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.5205,
    y: 18.5028,
    width: 39.0221,
    height: 7.31647,
    rx: 3.65824,
    transform: "rotate(-7.4625 18.5205 18.5028)",
    fill: "#9B5AE6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.26904,
    y: 8.60181,
    width: 26.1966,
    height: 7.31647,
    rx: 3.65824,
    transform: "rotate(26.5377 3.26904 8.60181)",
    fill: "#9B5AE6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.7358,
    y: 34.8047,
    width: 22.583,
    height: 7.31647,
    rx: 3.65824,
    transform: "rotate(-0.558177 16.7358 34.8047)",
    fill: "#9B5AE6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32.6831,
    y: 41.9742,
    width: 23.7513,
    height: 7.31647,
    rx: 3.65824,
    transform: "rotate(-89.3057 32.6831 41.9742)",
    fill: "#9B5AE6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 51.9688,
    y: 42.3643,
    width: 23.7513,
    height: 6.45028,
    rx: 3.22514,
    transform: "rotate(-95.0213 51.9688 42.3643)",
    fill: "#9B5AE6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 69.1113,
    y: 24.476,
    width: 19.3152,
    height: 5.86956,
    rx: 2.93478,
    transform: "rotate(-161.922 69.1113 24.476)",
    fill: "#9B5AE6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 83.8457,
    y: 14.3489,
    width: 19.3152,
    height: 5.86956,
    rx: 2.93478,
    transform: "rotate(146.37 83.8457 14.3489)",
    fill: "#9B5AE6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursoPilates);
export default __webpack_public_path__ + "static/media/curso_pilates.3c59f10c5f70b31d0c9fda006f73371c.svg";
export { ForwardRef as ReactComponent };